import { BuildingStorefrontIcon } from "@heroicons/react/24/solid";
import AddButton from "components/AddButton";
import CloseIconButton from "components/CloseIconButton";
import EditOutlineButton from "components/EditOutlineButton";
import { mainSelectedTab } from "modules/CarrierAgreementMgmt/atoms";
import { permissionsSelector } from "modules/Login/selectors/permissionSelector";
import { OfficeTabs } from "modules/OfficeTab/OfficeTabs";
import { PERMISSIONS } from "modules/PermissionsConstants";
import { useHistory } from "react-router-dom";
import { useRecoilState, useRecoilValue } from "recoil";
import { OfficeApplianceGeneralInfo } from "./OfficeApplianceGeneralInfo";
import { OfficeApplianceSystemInfo } from "./OfficeApplianceSystemInfo";
import { useGetOfficeApplianceById } from "../hooks/useGetOfficeApplianceById";

export const OfficeApplianceViewDetails = ({
  applianceDetails,
  handleEdit,
  onclickCancelShow,
  setIsAddState,
}) => {
  const { data: officeApplianceDetails, isFetching } =
    useGetOfficeApplianceById(applianceDetails?.officeApplianceId);

  //#region States
  const [, setSelectedIndex] = useRecoilState(mainSelectedTab);
  const history = useHistory();

  //#region Permissions
  const userPermissions = useRecoilValue(permissionsSelector);
  const addPermission = PERMISSIONS.permission_officeappliance_add;
  const editPermission = PERMISSIONS.permission_officeappliance_edit;
  //#endregion

  //#region Navigate To Office
  const navigateToOffice = () => {
    const url = "/officesettings/officesetting";
    history.push({
      pathname: url,
      state: {
        applianceData: applianceDetails,
        pathname: url,
        officeId: applianceDetails.officeId,
        action: "OfficeApplianceView",
      },
    });
    const userTabs: any = [];

    for (const tab of OfficeTabs) {
      if (userPermissions.includes(tab.permission)) {
        userTabs.push({ to: tab.to });
      }
    }

    const index = userTabs.findIndex((t) => t.to === url);
    setSelectedIndex(index);
  };
  //#endregion

  return (
    <>
      {!isFetching && (
        <>
          <div className="flex mx-4 justify-between pb-1 border-secondary border-b-2">
            <div className="flex gap-2 items-center">
              <div>
                <BuildingStorefrontIcon className="text-white bg-blue-500 rounded-md h-7 w-7 p-1" />
              </div>
              <div className="flex flex-col leading tight">
                <h3 className="text-xs font-medium text-gray-500">
                  Office Appliance
                </h3>
                <h1 className="mr-auto font-bold text-primary text-md uppercase">
                  <span className="pr-2">
                    {"A-" +
                      String(
                        officeApplianceDetails.officeApplianceId
                      )?.padStart(4, "0")}
                  </span>
                </h1>
              </div>
            </div>
            <div className="flex justify-between">
              <div className="flex items-center gap-2">
                {userPermissions.includes(addPermission) ? (
                  <AddButton
                    className={"opacity-100"}
                    disabled={false}
                    buttonText="Add"
                    onClick={() => {
                      setIsAddState(true);
                    }}
                  />
                ) : (
                  ""
                )}
                {userPermissions.includes(editPermission) ? (
                  <EditOutlineButton
                    buttonText="Edit"
                    className={""}
                    disabled={false}
                    onClick={() => {
                      handleEdit(officeApplianceDetails);
                    }}
                  />
                ) : (
                  ""
                )}
              </div>
              <CloseIconButton onClick={() => onclickCancelShow()} />
            </div>
          </div>

          <div className="bg-bgDB">
            <OfficeApplianceGeneralInfo
              navigateToOffice={navigateToOffice}
              applianceDetails={officeApplianceDetails}
            />
            <OfficeApplianceSystemInfo
              applianceDetails={officeApplianceDetails}
            />
          </div>
        </>
      )}
    </>
  );
};
